(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/use-trigger-payment.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/use-trigger-payment.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useRef = _React.useRef;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation;
const QS_FRACTION_DATA = svs.components.marketplaceShared.sharedConstants.constants.QS_FRACTION_DATA;
const useTriggerPayment = (activatedDrawId, groupId, isCurrentUserAuthenticated) => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const marketplaceFractionData = searchParams.get(QS_FRACTION_DATA);
  const _ref = (marketplaceFractionData === null || marketplaceFractionData === void 0 ? void 0 : marketplaceFractionData.split('_')) || [],
    _ref2 = _slicedToArray(_ref, 2),
    queryActivatedDrawId = _ref2[0],
    queryGroupId = _ref2[1];
  const ref = useRef(false);
  const clearPaymentTrigger = () => {
    ref.current = false;
    searchParams.delete(QS_FRACTION_DATA);
    if (history.location.state) {
      history.location.state.hasBackButton = true;
    } else {
      history.location.state = {
        hasBackButton: true
      };
    }
    history.replace({
      search: searchParams.toString()
    });
  };
  if (isCurrentUserAuthenticated && queryActivatedDrawId && queryGroupId) {
    if (parseInt(queryActivatedDrawId, 10) === activatedDrawId && parseInt(queryGroupId, 10) === groupId) {
      ref.current = true;
    }
  }
  return {
    triggerPayment: ref.current,
    clearPaymentTrigger
  };
};

setGlobal('svs.components.marketplace.fractionPayment.useTriggerPayment', useTriggerPayment);

 })(window);